import React, { useRef } from "react";
import { Table } from "react-bootstrap";
import { DownloadTableExcel } from "react-export-table-to-excel";

const AccountLedgerExport = ({
  transactions,
  newOpeningBln,
  customToRise,
  gettotalCredit,
  gettotaldebit,
  from,
  toDate,
  sub_AccountData,
  balance,
  subtoatal,
}) => {
  const tableRef = useRef(null);

  return (
    <>
      <DownloadTableExcel
        filename="Account Ledger"
        sheet="Account Ledger"
        currentTableRef={tableRef.current}
      >
        <button className="btn btn-primary mx-2"> Export </button>
      </DownloadTableExcel>

      <Table responsive ref={tableRef} style={{ display: "none" }}>
        <thead>
          <tr id="tbl">
            <th>Date</th>
            <th>VNoVType</th>
            <th>Description</th>
            <th>Debit</th>
            <th>Credit</th>
            <th className="text-center">Balance</th>
          </tr>
          <tr id="tbl">
            <th></th>
            <th></th>
            <th>Opening Balance</th>
            <th>{newOpeningBln?.openning_balance_debit}</th>
            <th>{newOpeningBln?.openning_balance_credit}</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {transactions &&
            transactions.map((item, index) => (
              <tr id="tbl" key={index}>
                <td style={{ color: "black" }} className="text_align_start">
                  {item?.voucher?.date}
                </td>
                <td style={{ color: "black" }} className="text_align_start">
                  {item.voucher?.voucher_no}
                </td>
                <td style={{ color: "black" }} className="text_align_start">
                  {item.remarks}
                </td>

                <td style={{ color: "black" }} className="text_align_start">
                  {item.debit}
                </td>
                <td style={{ color: "black" }} className="text_align_start">
                  {item.credit}
                </td>
                <td style={{ color: "black", width: "150px" }}>
                  {Math.abs(item.blnc)}{" "}
                  {Math.abs(item.blnc) != 0 ? item.type : ""}
                </td>
              </tr>
            ))}
          {subtoatal ? (
            <>
              <tr id="tbl" style={{ borderTop: "1px solid black" }}>
                <td
                  style={{ color: "black" }}
                  className="text_align_start"
                ></td>
                <td
                  style={{ color: "black" }}
                  className="text_align_start"
                ></td>
                <td
                  style={{ color: "black" }}
                  className="text_align_start"
                ></td>

                <td
                  style={{ color: "black", fontWeight: "bolder" }}
                  className="text_align_start"
                >
                  {gettotaldebit()}
                </td>
                <td
                  style={{ color: "black", fontWeight: "bolder" }}
                  className="text_align_start"
                >
                  {gettotalCredit()}
                </td>

                <td style={{ color: "black" }}></td>
              </tr>
            </>
          ) : null}

          {subtoatal ? (
            <>
              <tr id="tbl" style={{ borderTop: "1px solid black" }}>
                <td
                  style={{ color: "black" }}
                  className="text_align_start"
                ></td>
                <td
                  style={{ color: "black" }}
                  className="text_align_start"
                ></td>
                <td
                  style={{ color: "black" }}
                  className="text_align_start"
                ></td>

                <td
                  style={{ color: "black" }}
                  className="text_align_start"
                ></td>
                <td
                  style={{ color: "black", fontWeight: "bolder" }}
                  className="text_align_start"
                >
                  Grand Total
                </td>

                <td style={{ color: "black" }}>
                  {customToRise == 1
                    ? Math.abs(balance - gettotalCredit() + gettotaldebit())
                    : Math.abs(
                        balance + gettotalCredit() - gettotaldebit()
                      )}{" "}
                  {transactions[transactions?.length - 1]?.blnc != 0
                    ? transactions[transactions?.length - 1]?.type
                    : ""}
                </td>
              </tr>
            </>
          ) : null}
        </tbody>
      </Table>
    </>
  );
};

export default AccountLedgerExport;
